// @flow
import {Route, Switch} from "react-router-dom"
import * as React from "react"
import {List, ListItem} from "material-ui/List"
import {CardText} from "material-ui/Card"
import Button from "material-ui/RaisedButton"
import {Toolbar, ToolbarGroup, ToolbarTitle} from "material-ui/Toolbar"
import _ from "lodash"
import QueryString from "query-string"
import withState from "recompose/withState"
import * as Util from "../common"
import {containers} from "@swarm2/core"

const FM = Util.intlMessages("flags")

function DebugIndexUnitRender(props) {
  if (props.isError) return <Util.Error error={props} />
  return (
    <tr>
      <td>{props.unitName}</td>
      <td style={{textAlign: "right"}}>
        <Util.Num val={props.rawCount} />
      </td>
      <td style={{textAlign: "right"}}>
        +<Util.Num small val={props.velocity} />/sec =
      </td>
      <td style={{textAlign: "right"}}>
        <Util.Num val={props.count} />
      </td>
    </tr>
  )
}
const DebugIndexUnit = containers.debug.DebugIndexUnit(DebugIndexUnitRender)

function DebugCharRender(props) {
  const {displayName, updatedAt, sinceUpdated, unitNames, charId} = props
  const sinceUpdatedSec = Math.floor(props.sinceUpdated / 1000)
  return (
    <div>
      <h4>Character: {displayName}</h4>
      <p>
        units reified: <Util.FromNow since={updatedAt} /> ({sinceUpdatedSec}s,{" "}
        {sinceUpdated}ms)
      </p>
      <table>
        <tbody>
          {unitNames.map(unitName => (
            <DebugIndexUnit
              key={unitName}
              unitName={unitName}
              charId={charId}
            />
          ))}
        </tbody>
      </table>
    </div>
  )
}
const DebugChar = containers.debug.DebugChar(DebugCharRender)
function alterLocationQS(qs) {
  const location = window.document.location
  const search = QueryString.stringify(qs)
  const a = document.createElement("a")
  a.href = location.href
  a.search = search
  return a.href
}
function toggleHref(name, value) {
  const toggleValue = !value
  const location = window.document.location
  const qs0 = QueryString.parse(location.search)
  // The line below produces prettier urls, but less correct when setting false
  //const qs = toggleValue ? {...qs0, [name]: true} : _.omit(qs0, [name])
  const qs = {...qs0, [name]: toggleValue}
  return alterLocationQS(qs)
}
function FlagRender(props) {
  if (props.isError) return <Util.Error inline error={props} />
  const {flagName, flagValue} = props
  if (typeof flagValue === "boolean") {
    const href = toggleHref(flagName, flagValue)
    //console.log(flagName, href)
    return (
      <ListItem
        primaryText={
          <div>
            <input
              type="checkbox"
              checked={flagValue}
              onChange={() => (document.location.href = href)}
            />{" "}
            <b>
              <a href={href}>{flagName}</a>
            </b>: {JSON.stringify(flagValue)}
          </div>
        }
        secondaryText={
          <span style={{color: "inherit"}}>
            <FM id={flagName} />
          </span>
        }
      />
    )
  }
  return (
    <ListItem
      primaryText={flagName + ": " + JSON.stringify(flagValue)}
      secondaryText={<FM id={flagName} />}
    />
  )
}
const Flag = containers.debug.Flag(FlagRender)

function DebugIndexRender(props) {
  if (props.isError) return <Util.Error error={props} />
  //console.log("DebugIndex", props)
  const versions = _.pick(props, [
    "clientVersionDate",
    "clientVersion",
    "clientLongVersion",
    "clientLongHash",
    "clientShortHash",
  ])
  const clearHref = alterLocationQS({})
  return (
    <div>
      <Toolbar>
        <ToolbarGroup>
          <ToolbarTitle text="Debug" />
        </ToolbarGroup>
      </Toolbar>
      <CardText>
        <p>
          Unlike swarmsim, this debug page won't let you edit your character.
          That means I can leave it on in production!
        </p>
        <div>
          <h4>Version</h4>
          <pre>{JSON.stringify(versions, null, 2)}</pre>
          <p>
            Client deployed <Util.FromNow since={props.clientVersionDate} />
          </p>
        </div>
        <div>
          <h4>Flags</h4>
          <div>
            {clearHref === document.location.href ? null : (
              <a href={alterLocationQS({})}>clear URL flags</a>
            )}
          </div>
          <List>
            {props.flagNames.map(flag => (
              <Flag key={flag} flagName={flag} charId={props.charId} />
            ))}
          </List>
        </div>
        <div>
          <TestErrorButton />
        </div>
        {props.charId ? <DebugChar {...props} /> : null}
      </CardText>
    </div>
  )
}
const DebugIndex = containers.debug.DebugIndex(Util.DumpProps(DebugIndexRender))

const TestErrorButton = withState("throwUp", "setThrowUp", false)(function(
  props,
) {
  if (props.throwUp) {
    throw new Error("test error please ignore")
  }
  // Throwing from onClick isn't caught by componentDidCatch()! It only catches
  // errors in the component lifecycle.
  return (
    <Button
      onClick={props.setThrowUp}
      label="Throw test lifecycle error"
      secondary
    />
  )
})

export function DebugView({match}: Object) {
  return (
    <div>
      <Switch>
        <Route exact path={match.path + "/"} component={DebugIndex} />
        <Route component={Util.NotFoundView} />
      </Switch>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/debug/DebugView.js